import React from "react";
import "./AppCheckListItem.css";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const AppCheckListItem = ({ title, isComplete }) => {
  return (
    <div className="app-check-list-item">
      <div className={`check-box ${isComplete ? "checked" : "unchecked"}`}>
        {isComplete && <CheckIcon />}
        {!isComplete && <CloseIcon />}
      </div>
      <div className="title">{title}</div>
    </div>
  );
};

export default AppCheckListItem;
